import { Injectable, inject } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { AuthStatusService } from '@fpr/core/services/auth-status.service';
import { ConfigService } from '@fpr/core/services/config.service';
import { ConversationService } from '@fpr/core/services/conversation.service';
import { WINDOW } from '@fpr/core/services/window.factory';

@Injectable()
export class ConversationInterceptor implements HttpInterceptor {
    private readonly authStatusService = inject(AuthStatusService);
    private readonly configService = inject(ConfigService);
    private readonly conversationService = inject(ConversationService);
    private readonly window = inject<Window>(WINDOW);


    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        return this.authStatusService
            .getSwid()
            .pipe(
                mergeMap(swid => {

                    const modifiedHeaders = req.headers
                        .set('X-Conversation-Id', this.conversationService.getConversationId())
                        .set('X-Correlation-Id', this.conversationService.getCorrelationId())
                        .set('X-App-Id', this.configService.APP_ID)
                        .set('X-Brand', this.configService.BRAND)
                        .set('X-App-Version', this.window['__parkPassVersion'])
                        .set('X-Swid', swid);

                    const modifiedReq = req.clone({
                        headers: modifiedHeaders
                    });

                    return next.handle(modifiedReq);

                })
            );

    }

}

